import { StoreScreen } from '../features/stores/StoreScreen'
import { useShell } from '../app/outlet'

export function StorePage() {
  const { toast } = useShell()
  return <StoreScreen onToast={toast} />
}
